<template>
	<div class="Modal">
		<button class="Modal-close-button" type="button" aria-label="Close modal" @click="closeModal">×</button>
		<form method="post" action="/" @submit.prevent="onSubmitForm">
			<h1 class="thermo">Wijzig het e-mailadres voor {{ company.companyname }}</h1>
			<div class="container">
				<input v-model="email">
				<Button :primary="true" type="submit" ref="submitButton">Wijzig</Button>
			</div>
			<span class="error-message" v-if="isValid === false">Mag niet leeg zijn</span>
		</form>
	</div>
</template>

<script>
import Button from '@/components/Button';
import {client} from "../../store";
import {mapActions} from "vuex";

export default {
	name: "ChangeEmail",

	components: {
		Button,
	},

	props: {
		company: Object
	},

	data() {
		return {
			email: '',
			isValid: true
		};
	},

	methods: {
		...mapActions({
			setLoading: "map/setLoading",
			setIdle: "map/setIdle"
		}),

		onSubmitForm() {
			this.setLoading();
			if (this.email.trim() === "") {
				this.isValid = false;
				return;
			} else {
				this.isValid = true;
			}

			const query = `
				mutation ($id: ID, $email: String) {
					changeEmail(id: $id, email: $email) {
						id
					}
				}
			`;

			client.query(query, {
				id: this.company.id,
				email: this.email
			}).then(() => {
				this.$notify({
					group: "app",
					title: "E-mail aangepast",
					type: "success",
					text: "E-mailadres is succesvol aangepast"
				});

				this.closeModal();
				this.$events.emit("map/closePopup");
			}).catch(() => {
				this.$notify({
					group: "app",
					title: "E-mail aanpassen mislukt",
					type: "error",
					text: "E-mailadres aanpassen is niet gelukt"
				});
			}).finally(() => {
				this.setIdle();
			});
		},

		closeModal() {
			this.$emit('close');
		}
	},

	beforeMount() {
		this.email = this.company.email;
	}
}
</script>

<style lang="scss" scoped>
	.container {
		display: flex;
		justify-content: space-between;
		gap: 1rem;

		input {
			width: 100%;
			padding: 10px;
			border: 2px solid #ced6dd;
			border-radius: 5px;
			box-shadow: none;
			background: #FFF;
			font-size: 1rem;
		}

		button {
			border-radius: 5px;
		}
	}

	.error-message {
		display: block;
		margin-top: 1rem;;
		color: red;
	}
</style>
